import { render, staticRenderFns } from "./SkuModal.vue?vue&type=template&id=084c2baa"
import script from "./SkuModal.vue?vue&type=script&lang=js"
export * from "./SkuModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports